<template>

        <div class="content_box">
            <v-snackbar
                v-model="ipWhitelistApiFailed"
                top center :timeout=10000
                :color="errorColor"> 
                <v-icon dark>warning</v-icon> &nbsp;&nbsp;
                <span>Api failed</span>
                <v-btn :color="errorColor" flat @click="ipWhitelistApiFailed = null; ipWhitelistApiFailed = false;" class="black--text snackbar-button">Close</v-btn>
            </v-snackbar>
            <v-card class="settings_panel_card" flat>
                <v-toolbar flat dense class="settings_toolbar">
                    
                    <v-toolbar-title class="settings_panel_heading">IP whitelist</v-toolbar-title>

                    <v-spacer></v-spacer>
                    <v-btn depressed icon small>
                        <v-icon :class="showByDefaultAdd ? '' : 'disabled'" @click="addRowIpwhiteList()" id="addIPToList">add</v-icon>
                    </v-btn>

                </v-toolbar>
                <div class="apps_table_div">
                    <table class="apps_component_table">
                        <thead>
                        <tr>
                            <th>IP</th>
                            <th>last Used</th>
                            <th>Actions</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(items,index) in getIpwhitelistResponseData" :key="items['lastUse'] + index">
                            <td class="alignment_for_data">
                                <v-icon class="purple--text">language</v-icon>&nbsp;
                                {{items.ip || 'xxxx:xx:xx:xx:xx'}}
                            </td>
                            <td class="alignment_for_data">{{items.lastUse || '0000:00:00'}}</td>
                            <td class="ip_actions "><i class="material-icons delete" id="deleteIP" @click="saveOrDeleteRow(index,items,'delete')" :class="getIpwhitelistResponseData.length == 1 ? 'lastIp': ''">delete</i></td>
                        </tr>
                        <tr v-for="(row,index) in ipwhitelistTableRow" :key="index">
                            <td v-if="addrowDataIpwhitelist && index == newIndex">
                                <input type="text" id="addIP" v-model="ipwhitelistDefaultIp.ip" class="apps_tableRow" :class="invalidIPRange ? 'error-text': ''"/>
                            </td>
                            <td></td>
                            <td class="action_icons">
                                <i class="material-icons check_circle_outline access-token__icons" :class="invalidIPRange ? 'disabled' : ''"  v-if="addrowDataIpwhitelist && index == newIndex" @click="saveOrDeleteRow(index,'ipWhitelist','save')">check_circle_outline</i>
                                <i class="material-icons highlight_off access-token__icons" v-if="addrowDataIpwhitelist && index == newIndex" @click="closeRowIntables('ipwhitelist')">highlight_off</i>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </v-card>
        </div>
</template>
<script>
import Vue from 'vue';
import {hideLoadIcon,showLoadIcon} from '../../../common/assets/utils/load.js';
export default {
    name:'ipwhitelist',
    props: {
        apptoken: {
            type: String
        },
        nodeValue:{
            type: String
        }
    },
    data(){
        return{
            ipWhitelistApiFailed:false,
            errorColor: 'error-banner',
            showByDefaultAdd:true, 
            getIpwhitelistResponseData:[], 
            ipwhitelistTableRow:[], 
            newIndex:-1,
            ipwhitelistDefaultIp:'',
            addrowDataIpwhitelist : false,
            invalidIPRange: true,
            hide:null
        }
    },
    mounted(){
        var self = this;
        self.ipwhitelistApi(self.apptoken);
    },
    watch:{
        ipwhitelistDefaultIp:{
            handler(){
                let cidrNumber = this.ipwhitelistDefaultIp.ip.split('/')[1] ? this.ipwhitelistDefaultIp.ip.split('/')[1] : "0";
                if(cidrNumber > 23 && cidrNumber < 33){
                    this.invalidIPRange = false;
                }else{
                    this.invalidIPRange = true;
                }
            },
            deep: true
        },
        apptoken(){
            var self = this;
            self.ipwhitelistApi(self.apptoken);
        }
    },
    methods:{

        // API call to get ipwhitelist data
        ipwhitelistApi(tokens,index){
            var self = this;
            showLoadIcon();
            this.$loading(true);
            Vue.http.get('/ipwhitelist/',{
            params:{
                    'apptoken' : tokens,
                    'node':self.nodeValue
                }
            })
            .then((response)=>{
                try{
                    self.getIpwhitelistResponseData = response.data;
                    for(var item in self.getIpwhitelistResponseData){
                        if(self.getIpwhitelistResponseData[item].lastUse == null){
                            self.getIpwhitelistResponseData[item].lastUse = 'unused';
                        }
                        else{
                            var date = new Date(self.getIpwhitelistResponseData[item].lastUse * 1000) .toString();
                            var time_to_display = date.substring(0,date.length);
                            self.getIpwhitelistResponseData[item].lastUse = time_to_display;
                        }
                    }
                }
                catch(err){
                    console.log("error is:",err);
                }
                finally{
                    self.hide = hideLoadIcon();
                    if(!self.hide){
                        this.$loading(false);
                    }
                }
            },(error) => {
                self.hide = hideLoadIcon();
                if(!self.hide){
                    this.$loading(false);
                }
                self.ipWhitelistApiFailed = true;
                setTimeout(function (){
                    self.ipWhitelistApiFailed = false
                },3000);
            });
        },


        // method to add row in ipwhitelist table
        addRowIpwhiteList(){
            var self = this;
            self.ipwhitelistTableRow = [];
            self.showByDefaultAdd = false;
            var today = new Date();
            self.newIndex = self.ipwhitelistTableRow.length;
            self.ipwhitelistTableRow.push({
                ip:'',
                lastUsed: today, 
            })
            let formData = new FormData();
            formData.append('json', JSON.stringify({ 'apptoken':self.apptoken, 'action':'add'}));
            showLoadIcon();
            this.$loading(true);
            Vue.http.get('/ip_address/',formData)
            .then((response) => {
                try{
                    self.ipwhitelistDefaultIp = response.data;
                }
                catch(err){
                    console.log("error is:",err);
                }
                finally{
                    self.hide = hideLoadIcon();
                    if(!self.hide){
                        this.$loading(false);
                    }
                }
            }, (error) => {
                self.hide = hideLoadIcon();
                if(!self.hide){
                    this.$loading(false);
                }
                self.ipWhitelistApiFailed = true;
                setTimeout(function (){
                    self.ipWhitelistApiFailed = false
                },3000);

            });
            
            self.addrowDataIpwhitelist = true;
        },

        // method to close the row in table

        closeRowIntables(ele){
            var self = this;
            self.showByDefaultAdd = true;
            if(ele == 'ipwhitelist'){
                self.ipwhitelistTableRow = [];
            }
        },

        // save and delete row ipwhitelist
        saveOrDeleteRow(index,type,action){
            var self = this;
            let formData = new FormData();
            if(action == 'save'){
                if(type == 'ipWhitelist'){
                    self.newIndex = index;
                    self.showByDefaultAdd = true;
                    self.addrowDataIpwhitelist = false;
                    formData.append('json', JSON.stringify({'apptoken': self.apptoken,
                    'action':'add',
                    'ip': self.ipwhitelistDefaultIp.ip,
                    'node':self.nodeValue}));
                }
                else{
                    self.new_Index = index;
                    self.addrow_data_tokens = false;
                }
            }
            // else case for deleting ip
            else{
                if(self.getIpwhitelistResponseData.length > 1){
                    formData.append('json', JSON.stringify({'apptoken': self.apptoken,
                    'action':'delete',
                    'ip':type.ip,
                    'node':self.nodeValue}));
                }
            }
            showLoadIcon();
            this.$loading(true);
            Vue.http.post('/ipwhitelist/',formData)
            .then((response) => {
                try{
                    self.ipwhitelistApi(self.apptoken);
                }
                catch(err){
                    console.log("error is:",err);
                }
                finally{
                    self.hide = hideLoadIcon();
                    if(!self.hide){
                        this.$loading(false);
                    }
                }
            }, (error) => {
                self.hide = hideLoadIcon();
                if(!self.hide){
                    this.$loading(false);
                }
                self.ipWhitelistApiFailed = true;
                setTimeout(function (){
                    self.ipWhitelistApiFailed = false
                },2000);

            });
        },
        showLoadIcon,
        hideLoadIcon
    }
}
</script>
<style scoped lang="scss">
  .snackbar-button {
        box-shadow: none ;
    }
</style>

